<div class="modal-header container-fluid">
  <h4 class="modal-title header-2">{{ title }}</h4>
  <button
    type="button"
    class="accello-icon-btn"
    (mousedown)="isActive = true"
    (mouseup)="isActive = false"
    (mouseleave)="isActive = false"
    (click)="activeModal.dismiss('Cross click')"
  >
    <img
      alt="close"
      [src]="
        isActive
          ? 'assets/images/virtusa-icons/close-dark.svg'
          : 'assets/images/virtusa-icons/close.svg'
      "
    />
  </button>
</div>
<div class="modal-body container-fluid overflow-auto w-100">
  <div class="d-flex flex-column gap-1">
    <span class="story-id">{{ data?.key || data?.userStoryId }}</span>
    <span class="story">{{ data?.storysummary }}</span>

    @for (item of contentList; track item) {
      <label class="item-label mb-0 me-3 label-width"> {{ item.name }} </label>
      <div
        *ngIf="shouldRenderMarkdown(data[item.mapping], item.mapping); else structuredContent"
        class="markdown-content item-value"
        [innerHTML]="data[item.mapping] | markdown"
      ></div>
      <ng-template #structuredContent>
        <ng-container *ngIf="getProcessedContent(data[item.mapping], item.mapping) as content">
          <ol *ngIf="content.type === 'numbered'" class="numbered-list">
            <li *ngFor="let line of content.items">{{ line }}</li>
          </ol>
          <ul *ngIf="content.type === 'bullets'" class="bullet-list">
            <li *ngFor="let line of content.items">{{ line }}</li>
          </ul>
          <span *ngIf="content.type === 'plain'" class="item-value preserve-whitespace">
            {{ content.items.length ? content.items[0] : "-" }}
          </span>
        </ng-container>
      </ng-template>
    }
  </div>
</div>

<div class="modal-footer">
  <div class="d-flex justify-content-end w-100">
    <button
      class="btn-accello-primary-light"
      (click)="activeModal.dismiss('Cross click')"
    >
      Close
    </button>
  </div>
</div>
